import { useState } from 'react';
import { GmailInboxToTriageTab } from './GmailInboxToTriageTab';
import { GmailInboxIgnoredTab } from './GmailInboxIgnoredTab';

type Tab = 'queued' | 'ignored';

export function GmailInboxPage() {
  const [tab, setTab] = useState<Tab>('queued');

  return (
    <div className="main-container-gdm max-w-4xl mx-auto">
      <div className="border-b mb-4">
        <nav className="flex gap-1">
          <button
            onClick={() => setTab('queued')}
            className={`px-4 py-2 text-sm border-b-2 ${tab === 'queued' ? 'border-cime-primary text-cime-primary' : 'border-transparent text-gray-600 hover:text-gray-900'}`}
          >
            À trier
          </button>
          <button
            onClick={() => setTab('ignored')}
            className={`px-4 py-2 text-sm border-b-2 ${tab === 'ignored' ? 'border-cime-primary text-cime-primary' : 'border-transparent text-gray-600 hover:text-gray-900'}`}
          >
            Mails ignorés (7j)
          </button>
        </nav>
      </div>

      {tab === 'queued' && <GmailInboxToTriageTab />}
      {tab === 'ignored' && <GmailInboxIgnoredTab />}
    </div>
  );
}
